/* eslint-disable arrow-body-style */
/* eslint-disable semi */
export default ({ team, owner, manager, matchSeo }) => {
  if (!team.name) {
    return '';
  }
  return `
    <div class="section section__large js-my-team">
      <div class="section__separator"></div>
      <div class="section-head d-flex team justify-content-between flex-wrap">
          <div class="d-flex align-content-center">
              <div
                  class="section-head__logo square d-flex text-center justify-content-between align-content-center">
                   ${team.logo ? (`
                       <img class="section-head__image m-auto js-open-logos"
                      src="/html/cornerkick/assets/images/match/teamlogo/${team.logo}.png" alt="" />
          `) : (`
              <img class="section-head__image m-auto js-open-logos"
                      src="/html/cornerkick/assets/images/logo/logo.png" alt="" />
          `)}
              </div>
              <div class="section-head__titles align-items-center" style="margin-right: 20px;" >
                  <span class="section-head__titles_country">${manager}</span>
                  <span class="section-head__titles_director">${team.name || 'Create Your Team Name'}</span>
                  <span class="section-head__titles_id">${owner}</span>
              </div>
              <div class="section-head__titles align-items-center">
                 <span class="d-flex align-items-center justify-content-center text-center section-head__titles_id" style="margin-bottom: 10px;">
                  <img style="width: 20px; margin-right: 10px;" class="my-team__id" src="/html/cornerkick/assets/images/gallery/chz.png"/>
                  Chz Players
                </span>
                 <span class="d-flex align-items-center justify-content-center text-center section-head__titles_id" style="margin-bottom: 10px;">
                  <img style="width: 20px; margin-right: 10px;" class="my-team__id" src="/html/cornerkick/assets/images/gallery/free.png"/>
                  Free Players
                </span>
              </div>
          </div>
         <div class="section-head__items align-items-lg-center justify-content-lg-center d-flex flex-column flex-lg-row">
          ${matchSeo ? (`
            <a href="${matchSeo}" target="_blank" class="default-button mt-3 mt-lg-0"><span>Go to Match</span></a>
          `) : (`
            ${team.formation_id ? `${team.young_player_generated ? '' : `<button data-formation-id="${team.formation_id}" class="default-button js-claim-young-players mr-3"><span>Claim Young Players</span></button>`}` : ''}
            <button data-type="friendly" class="default-button js-create-match mr-3 mt-3 mt-lg-0"><span>Create Friendly Match</span></button>
            <button data-type="death" class="default-button js-create-match mt-3 mt-lg-0"><span>Create Death Match</span></button>
          `)}
         </div>
      </div>
    </div>
  `
};
